import React, { useState } from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { PopupAddNewSelect } from './popup-add-new-select';
import { ModalSize } from 'app/components/constants';

export interface PopupAddNewProps {
  title: string;
  addItems: (options: ComplexValue<number>[]) => void;
  addItemsVisible?: boolean;
  readOnlyItemIds?: number[];
  onClose: () => void;

  actionTitle?: string;
  onAction?: () => void;

  selectedValues?: ComplexValue<number>[];
  options: ComplexValue<number>[];
  fetchingOptions: boolean;
  loadOptions: (loadOptionsParams: LoadOptions) => void;

  descriptionAllLevels: boolean;
  doneLabel: string;
  searchPlaceholder: string;
  locale: string;
}

export const PopupAddNew: React.FC<PopupAddNewProps> = ({
  title, addItems, addItemsVisible, onClose, actionTitle, onAction,
  selectedValues, options, fetchingOptions, loadOptions, readOnlyItemIds,
  descriptionAllLevels, doneLabel, searchPlaceholder, locale
}) => {

  const [valueItems, setValueItems] = useState<ComplexValue<number>[]>(selectedValues ?? []);

  const handleAddValueItems = () => {
    addItems(valueItems);
    setValueItems([]);
  };

  const isDisabled = valueItems.length === 0 && !addItemsVisible;

  return <ModalWrapper
    headerTitle={title}
    btnTitle={doneLabel}
    btnExtraFooterActionTitle={actionTitle}
    onExtraFooterAction={onAction}
    onClose={onClose}
    onDone={handleAddValueItems}
    isDisabled={isDisabled}
    isExtraFooterActionDisabled={false}
    size={ModalSize.large}>
    <PopupAddNewSelect
      valueItems={valueItems}
      onChange={setValueItems}
      options={options}
      fetchingOptions={fetchingOptions}
      loadOptions={loadOptions}
      descriptionAllLevels={descriptionAllLevels}
      searchPlaceholder={searchPlaceholder}
      readOnlyItemIds={readOnlyItemIds}
      locale={locale}
    />
  </ModalWrapper>;
};
